module.exports = __webpack_public_path__ + "static/media/how-it-works-landlord-t3-10.9327851f.svg";